const KNOWN_ROLES = new Set(["scorer", "recorder", "single_score", "single_record"]);

// Match formats that play two innings (and therefore have an innings break):
// regular matches, and the Super Over challenge (play & chase). All other
// challenge types finish after one innings.
export function isTwoInningsMatch(match) {
  if (match?.mode === "full") return true;
  return match?.mode === "challenge" && match?.challenge?.type === "super_over";
}

export function effectiveDeviceRole(match, peerRole) {
  if (peerRole === "scorer" || peerRole === "recorder") return peerRole;
  return KNOWN_ROLES.has(match?._deviceRole) ? match._deviceRole : null;
}

export function liveScreenForDevice(match, peerRole) {
  const role = effectiveDeviceRole(match, peerRole);
  return role === "recorder" || role === "single_record" ? "recording" : "scoring";
}

export function resolveDeviceRoute(requestedScreen, match, peerRole) {
  if (!match) return requestedScreen;
  const role = effectiveDeviceRole(match, peerRole);

  if ((role === "scorer" || role === "single_score") &&
      (requestedScreen === "recording" || requestedScreen === "recorder-join")) {
    return "scoring";
  }
  if (role === "recorder" && requestedScreen === "scoring") return "recording";
  if (role === "single_record" && requestedScreen === "scoring") return "recording";
  return requestedScreen;
}

export function resumeScreenForMatch(match, peerRole, inningsOver) {
  if (match?.result) return "result";
  if (isTwoInningsMatch(match) && match?.innings?.length === 1 && inningsOver) return "break";
  return liveScreenForDevice(match, peerRole);
}

export function shouldOpenInningsBreakScreen(screen, match, peerRole) {
  const role = effectiveDeviceRole(match, peerRole);
  return screen === "scoring" && role !== "recorder" && role !== "single_record";
}

export function applyDeviceSession(match, role, roomCode = null) {
  if (!match || !KNOWN_ROLES.has(role)) return match;
  match._deviceRole = role;
  if (role === "scorer" && /^\d{6}$/.test(String(roomCode || ""))) {
    match._peerRoomCode = String(roomCode);
  } else {
    delete match._peerRoomCode;
  }
  return match;
}

export function stripLocalDeviceSession(match) {
  const clone = JSON.parse(JSON.stringify(match || {}));
  delete clone._deviceRole;
  delete clone._peerRoomCode;
  delete clone._undoStack;
  return clone;
}
